//React
import { useState, FunctionComponent } from "react";

//App Hooks
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectPageOfUnmatchedResults } from "../../redux/selectors/pagination/select-page-of-unmatched-results";
import { selectIsMobile } from "../../../system/redux/selectors/select-is-mobile";

//Components
import ResultCard from "./result-card";
import ResultLoadMorePager from "../pagination/result-load-more-pager";

interface ResultProps {}

const NearbyCommunitiesResultList: FunctionComponent<ResultProps> = (props) => {
	//State Values
	const isMobile = useAppSelector(selectIsMobile);
	const unmatchedPageOfResults = useAppSelector(selectPageOfUnmatchedResults);

	//JSX
	if (unmatchedPageOfResults?.length === 0) {
		return null;
	}

	return (
		<div className="results-set related-nearby-communities">
			<section className="list-view" id="other">
				<h2 className="content-bar-divider alt">
					<span>Other communities outside your search filters</span>
				</h2>
				<div className="mobile-scroll">
					<div className="home-grid scrollbar-chrome">
						<div className="NearbyResultList coveo-result-list-container coveo-list-layout-container nearby-results" role="list">
							{unmatchedPageOfResults?.map((result) => (
								<ResultCard
									key={result.uniqueId}
									result={result}
									isInInfoWindow={false}
								/>
							))}
						</div>
					</div>
				</div>
			</section>

			{/* Mobile shows all the matching results so we will use the load more for unmatched results */}
			{<ResultLoadMorePager />}
		</div>
	);
};

export default NearbyCommunitiesResultList;
